<template>
    <div class="text-center">
        <splide v-if="smallImages.length > 1"
                :options="options">
            <splide-slide v-for="(image, index) in smallImages"
                          :key="index">
                <div>
                    <img :src="image"
                         :alt="alt"
                         class="group-image"
                         @click="openLightboxOnSlide(index + 1)">
                </div>
            </splide-slide>
        </splide>
        <img v-else
             :src="smallImages[0]"
             :alt="alt"
             class="w-100"
             @click="toggler = !toggler">

        <FsLightbox v-if="bigImages.length > 1"
                    :slide="slide"
                    :toggler="toggler"
                    :sources="bigImages" />
        <FsLightbox v-else
                    :toggler="toggler"
                    :sources="bigImages" />
    </div>
</template>

<script>
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import FsLightbox from 'fslightbox-vue';

    export default {
        components: {
            Splide,
            SplideSlide,
            FsLightbox,
        },
        props: {
            smallImages: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            bigImages: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            alt: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                options: {
                    type: 'loop',
                    autoplay: true,
                    gap: '8px',
                    autoWidth: false,
                    pagination: false,
                },
                toggler: false,
                slide: 1,
            };
        },
        created() {
            this.options.autoWidth = window.innerWidth > 991;
        },
        methods: {
            openLightboxOnSlide(number) {
                this.slide = number;
                this.toggler = !this.toggler;
            },
        },
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/breakpoints" as breakpoints;

.one-image,
.group-image {
    width: 100%;
    cursor: pointer;
}

.one-image {
    max-height: 300px;
}

.group-image {
    height: 270px;

    @media (max-width: breakpoints.$lg-breakpoint-max-width) {
        height: unset;
    }
}
</style>
